import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Error from './Error';
import { ThemeProvider } from '@mui/material';
import { theme } from './generals/theme';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Footer3 from './generals/Footer3';
import Hero from './generals/Hero';
import Nav3 from './generals/Nav3';
import Home3 from './generals/Home3';
import Team from './generals/Team';
import Testimonials from './generals/Testimonials';
import Gallery from './generals/Gallery';
import FAQ from './generals/FAQ';
import PrivateChefs from './generals/PrivateChefs';
import RentalChefs from './generals/RentalChefs';
import Consulting from './generals/Consulting';
import Imprint from './generals/Imprint';
import PrivacyPolicy from './generals/PrivacyPolicy';
import Terms from './generals/Terms';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const router = createBrowserRouter([
    {
        path: '/',
        element: <>
            <Nav3 />
            <Hero />
            <Home3 />
            {/*
            <Team />
            <Testimonials />
            <Gallery />
            <FAQ />
            */}
            <Footer3 />
        </>,
        errorElement: <Error />,
    },
    {
        path: '/private-chefs',
        element: <>
            <Nav3 />
            <PrivateChefs />
            <Footer3 />
        </>,
        errorElement: <Error />,
    },
    {
        path: '/rental-chefs',
        element: <>
            <Nav3 />
            <RentalChefs />
            <Footer3 />
        </>,
        errorElement: <Error />,
    },
    {
        path: '/consulting',
        element: <>
            <Nav3 />
            <Consulting />
            <Footer3 />
        </>,
        errorElement: <Error />,
    },
    {
        path: '/imprint',
        element: <>
            <Nav3 />
            <Imprint />
            <Footer3 />
        </>,
        errorElement: <Error />,
    },
    {
        path: '/privacy-policy',
        element: <>
            <Nav3 />
            <PrivacyPolicy />
            <Footer3 />
        </>,
        errorElement: <Error />,
    },
    {
        path: '/terms',
        element: <>
            <Nav3 />
            <Terms />
            <Footer3 />
        </>,
        errorElement: <Error />,
    },
    {
        path: '*',
        element: <>
            <Nav3 />
            <Hero />
            <Home3 />
            {/*
            <Team />
            <Testimonials />
            <Gallery />
            <FAQ />
            */}
            <Footer3 />
        </>,
        errorElement: <Error />,
    },
]);

root.render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <RouterProvider router={router} />
            </LocalizationProvider>
        </ThemeProvider>
    </React.StrictMode>
);
